<script>
import { startsWith } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { fetchSingleUpload } from '@/api/upload';

library.add(faSpinner);

export default {
  name: 'FileUpload',
  props: {
    value: Object,
    directory: {
      type: String,
      required: true,
    },
    className: String,
    label: String,
    id: {
      type: String,
      default: 'image',
    },
    hideUploadButton: {
      type: Boolean,
      default: false,
    },
    additionalData: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      isUploading: false,
      imagePreview: null,
      videoPreview: null,
    };
  },
  watch: {
    value (newValue, oldValue) {
      if (newValue === oldValue || !newValue || !newValue.url) {
        return;
      }

      if (startsWith(newValue.mimeType, 'image/')) {
        this.imagePreview = newValue.url;
      }

      if (startsWith(newValue.mimeType, 'video/')) {
        this.videoPreview = newValue.url;
      }
    }
  },
  methods: {
    fileChange(event) {
      if (!event.target.files || !event.target.files.length) {
        return;
      }

      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('directory', this.directory);
      formData.append('fileName', file.name.split('.').slice(0, -1).join('.'));
      formData.append('file', new Blob([file]));

      if (this.additionalData) {
        Object.keys(this.additionalData).map(key => {
          formData.append(key, this.additionalData[key]);
        });
      }

      const reader = new FileReader();
      reader.onload = e => {
        const result = e.target.result;
        if (startsWith(result, 'data:video')) {
          this.videoPreview = result;
        }
        else if (startsWith(result, 'data:image')) {
          this.imagePreview = result;
        }
      };
      reader.readAsDataURL(file);

      this.isUploading = true;

      fetchSingleUpload(formData)
        .then(res => res.json())
        .then(res => {
          this.$emit('input', res);

          if (startsWith(res.mimeType, 'image/')) {
            this.imagePreview = res.url;
          }

          if (startsWith(res.mimeType, 'video/')) {
            this.videoPreview = res.url;
          }

          this.isUploading = false;
        })
        .catch(e => console.error(e))
      ;
    },
    setPreviews() {
      const { value } = this;
      if (!value || !value.mimeType || !value.url) {
        return;
      }

      if (startsWith(value.mimeType, 'image/')) {
        this.imagePreview = value.url;
      }

      if (startsWith(value.mimeType, 'video/')) {
        this.videoPreview = value.url;
      }
    },
  },
  created() {
    this.setPreviews();
  },
};
</script>
<style lang="scss" scoped>
  //eslint-disable
</style>
<template>
  <div :class="className">
    <div v-if="imagePreview && !isUploading">
      <img :src="imagePreview" alt="uploaded image" class="img-fluid pt-3" />
    </div>
    <div v-if="videoPreview && !isUploading">
      <video width="320" height="240" controls>
        <source :src="videoPreview" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div v-if="!isUploading">
      <label :for="id">{{ label }}</label>
      <input type="file" v-if="!hideUploadButton" class="form-control-file" :disabled="isUploading" :id="id" @change="fileChange($event)" />
    </div>
    <div v-else class="pt-3 text-center">
      <font-awesome-icon icon="spinner" size="3x" spin></font-awesome-icon>
    </div>
  </div>
</template>
